module.exports = __webpack_public_path__ + "img/gift-icon.7b996f4f.svg";